import { Component, Input } from '@angular/core'
import { AsyncPipe, NgIf } from '@angular/common'
import { MatIcon } from '@angular/material/icon'
import { MatIconButton } from '@angular/material/button'
import { MatTooltip } from '@angular/material/tooltip'
import { map } from 'rxjs'
import { ThemeService } from '../services/theme.service'
import { MatMenuItem } from '@angular/material/menu'

@Component({
  selector: 'sans-theme-icon',
  standalone: true,
  imports: [AsyncPipe, MatIcon, MatIconButton, MatTooltip, MatMenuItem, NgIf],
  templateUrl: './theme-icon.component.html',
  styleUrl: './theme-icon.component.css',
})
export class ThemeIconComponent {
  @Input() public isHamburgerMenuItem = false

  public themeTooltipLabel$ = this.themeService.theme$.pipe(
    map((theme) =>
      theme === 'Light'
        ? $localize`:Tooltip label|Light tooltip label:Switch to dark mode`
        : $localize`:Tooltip label|Dark tooltip label:Switch to light mode`,
    ),
  )

  public switchThemeLabel = $localize`:Label|ThemeIconComponent:Switch theme`

  public themeIconName$ = this.themeService.theme$.pipe(
    map((theme) => (theme === 'Light' ? 'dark_mode' : 'light_mode')),
  )

  public constructor(private themeService: ThemeService) {}

  public onToggleTheme(): void {
    this.themeService.toggleTheme()
  }
}
